import queryString from 'querystring';

function useIsOneRosterActivatedSchool() {
    const location = window.location;
    const queryParams = location.search;

    const query = queryParams.replace('?', '');
    const params = queryString.parse(query);

    return params.isOneRosterActivatedSchool === 'true';
}

export default useIsOneRosterActivatedSchool;



// WEBPACK FOOTER //
// ./hooks/use-is-one-roster-activated-school.js